import { type CheckOptions, type Condition, check, engineGlobals, type Row } from '@inixiative/json-rules';
import { widenDayPrecisionDates } from './widenDayPrecisionDates';

// gloss
export const checkRule = (rule: unknown, row: Row, options?: CheckOptions): boolean =>
  engineGlobals.with(
    { string: { caseInsensitive: true } },
    () => check(widenDayPrecisionDates(rule) as Condition, row, options) === true,
  );
